import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../BaseComponent";
import {RowClickEvent} from "devextreme/ui/data_grid";
import {DeviceLite, Gateway} from "../../../../../models/gateway/Gateway";
import {DeviceAlarmStatusEnum} from "../../../../../models/notification/DeviceAlarmStatus";
import {GatewayStatusEnum} from "../../../../../models/gateway/GatewayStatusEnum";
import {DuplicateDevicePendingConfigCB} from "../../../../../ope/gateway-pending-config/DuplicateDevicePendingConfigCB";
import {GatewayPendingConfigOpeService} from "../../../../../services/ope/gatewayPendingConfigOpe.service";
import {ChangeTypeEnum} from "../../../../../ope/gateway-pending-config/GatewayPendingConfigPayloadDTO";
import {RevertDevicePendingConfigCB} from "../../../../../ope/gateway-pending-config/RevertDevicePendingConfigCB";
import {
  CancelAllDevicePendingConfigCB
} from "../../../../../ope/gateway-pending-config/CancelAllDevicePendingConfigCB";

@Component({
  selector: 'app-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.css', '../../gateway-device.component.css']
})
export class DeviceTableComponent extends BaseComponent {

  @Output() onDeviceRowClick: EventEmitter<RowClickEvent> = new EventEmitter();
  @Output() showNewDeviceForm: EventEmitter<void> = new EventEmitter();
  @Output() updateDevicesRequest: EventEmitter<void> = new EventEmitter();

  @Input() selectedGatewayDevices?: DeviceLite[];
  @Input() selectedGateway?: Gateway;
  @Input() selectedRowDevice?: any;
  @Input() isGatewayDrawerOpen!: boolean;
  @Input() isGatewayPendingConfig!: boolean;

  protected readonly DeviceAlarmStatusEnum = DeviceAlarmStatusEnum;
  protected readonly ChangeTypeEnum = ChangeTypeEnum;
  protected readonly gatewayPendingConfigOpeService = inject(GatewayPendingConfigOpeService);


  getAcquisitionCronLabel = (acquisitionCron: string) => {
    return this.translate.instant('FREQUENCY.' + acquisitionCron);
  };

  duplicatingDevice?: DeviceLite;
  duplicateDeviceName: string = '';

  protected openDuplicateDevice($event: any, device: DeviceLite) {
    $event.stopPropagation();
    this.duplicatingDevice = device;
    const suffix = ' - ' + this.translate.instant('REGISTRY.DEVICE.TEXT.DUPLICATE_DEVICE_NAME_SUFFIX');
    this.duplicateDeviceName = device.name.slice(0, Math.max(this.gmService.STR_DIM_MID - suffix.length, 0)) + suffix;
  }

  protected duplicateDevice() {
    const cb = new DuplicateDevicePendingConfigCB();
    cb.i.deviceId = this.duplicatingDevice!.id;
    cb.i.gatewayId = this.duplicatingDevice!.gatewayId!;
    cb.i.name = this.duplicateDeviceName;

    this.gatewayPendingConfigOpeService.duplicateDevicePendingConfig(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.DUPLICATED"));
      this.duplicatingDevice = undefined;
      this.updateDevicesRequest.emit();
    });
  }

  protected revertDevicePendingConfig($event: any, data: DeviceLite) {
    $event.stopPropagation();
    this.sendRevertDeviceConfigCommand(data.gatewayId!, data.id);
  }

  /**
   * Call RevertDevicePendingConfigOPE
   */
  sendRevertDeviceConfigCommand(gatewayId: number, deviceId: number) {
    const cb: RevertDevicePendingConfigCB = new RevertDevicePendingConfigCB();
    cb.i.gatewayId = gatewayId;
    cb.i.deviceId = deviceId;

    this.gatewayPendingConfigOpeService.revertDevicePendingConfig(cb).then((_) => {

      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.UPDATED"));

      this.updateDevicesRequest.emit();

    }).catch((_) => {

      this.updateDevicesRequest.emit();
    });
  }

  get hasPendingDevices(): boolean {
    return !!this.selectedGatewayDevices?.some(d =>
      d.changeType === ChangeTypeEnum.CREATED || d.changeType === ChangeTypeEnum.UPDATED
      || d.changeType === ChangeTypeEnum.DELETED);
  }

  /**
   * Call CancelAllDevicePendingConfigOPE
   */
  cancelAllDevicePendingConfig() {
    const cb: CancelAllDevicePendingConfigCB = new CancelAllDevicePendingConfigCB();
    cb.i.gatewayId = this.selectedGateway!.id;

    this.gatewayPendingConfigOpeService.cancelAllDevicePendingConfig(cb).then((_) => {

      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.UPDATED"));

      this.updateDevicesRequest.emit();

    }).catch((_) => {

      this.updateDevicesRequest.emit();
    });
  }

}
